module.exports = __webpack_public_path__ + "img/icon_yctpf.4d16a5e5.png";